import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/braces.vue
var o = {
	name: "DtIconBraces",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--braces"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Braces",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M2 9.5V7a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1 .5.5 0 0 0 .49-.402L2 5V2.5A1.5 1.5 0 0 1 3.5 1H4a.5.5 0 0 1 0 1h-.5a.5.5 0 0 0-.5.5V5c0 .37-.14.725-.386 1 .247.275.386.63.386 1v2.5c0 .274.226.5.5.5H4a.5.5 0 0 1 0 1h-.5C2.674 11 2 10.326 2 9.5Zm7 0V7c0-.384.146-.734.385-1A1.498 1.498 0 0 1 9 5V2.5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 1 0-1h.5A1.5 1.5 0 0 1 10 2.5V5a.5.5 0 0 0 .5.5.5.5 0 0 1 .1.99l-.2.02A.504.504 0 0 0 10 7v2.5A1.5 1.5 0 0 1 8.5 11H8a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=braces.js.map